module.exports = __webpack_public_path__ + "static/agree-2c295b97c8526cdc67e0a42f8afa4c84.png";